import { createReducer } from '../../utilities';

import { CREATE_ALERT_IN_APP, CREATE_ALERT_IN_APP_SUCCESS, CREATE_ALERT_IN_APP_ERROR } from '../../../actions/entities/alertMPG'

const scope = "ALERT_MPG";

const initialAlertMPG = {
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: null,
        needRefresh: false,
        updatedAt: null,
        success: null,
        error: null,
    }
};

function request(state, action) {
    return {
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { lastResponse, receivedAt } = action;
    return {
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            lastResponse: lastResponse,
            updatedAt: receivedAt,
            success: true,
            error: false
        }
    }
}

function fail(state, action) {
    const { error } = action;
    return {
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialAlertMPG, {
    [CREATE_ALERT_IN_APP]: request,
    [CREATE_ALERT_IN_APP_SUCCESS]: success,
    [CREATE_ALERT_IN_APP_ERROR]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/alertMPG/create.js